import { Plural } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';

interface BookmarkDragOverlayProps {
  bookmarkIds: string[];
  bookmarkTitle?: string;
}

function BookmarkDragOverlay({ bookmarkIds, bookmarkTitle }: BookmarkDragOverlayProps) {
  const count = bookmarkIds.length;

  return (
    <div className="max-w-[200px] rotate-2 transform cursor-grabbing rounded-md border border-gray-200 bg-white px-3 py-2 opacity-30 shadow-lg">
      {count === 1 ? (
        <span className="block truncate text-sm font-medium">
          {bookmarkTitle || t`Moving article...`}
        </span>
      ) : (
        <span className="text-sm font-medium">
          <Plural value={count} one="# article" other="# articles" />
        </span>
      )}
    </div>
  );
}

export default BookmarkDragOverlay;
